<!--
/*******************************************************************************
*@ 화면명     : SelfCertnComm
*@ 화면설명   : SMS/E-MAIL 인증 공통처리
*@ 사용전문   : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!--"MOTP-01-07-01-01": "인증방법 선택",-->
    <!--"MOTP-01-07-01-02": "영업점에서 등록한 개인 휴대폰/이메일 정보나 발급받은 Token OTP를 통한 본인인증이 가능합니다. ",-->
    <div class="scroll">
      <contents-header
        :bg-type="true"
        :no-radius="true"
        :tabs="true"
        title="MOTP-01-07-01-01"
        description="MOTP-01-07-01-02"
      >
        <template #tab>
          <div class="tabs bg-type" id="tabs">
            <button
              class="tab-button tab-button--type1"
              v-for="(tab, index) in tabs"
              :class="{ active: currentTab === index }"
              @click="currentTab = index"
              :key="index"
            >
              <!--  휴대폰번호 or 이메일 / Token OTP -->
              <i v-if="token" class="icon icon-attestation2" />
              <!--  휴대폰번호 or 이메일 / Mobile OTP  -->
              <i v-else class="icon icon-attestation3" />
              <span class="btn-text">{{ tab }}</span>
            </button>
          </div>
        </template>
      </contents-header>

      <!-- {{getSendCetrNo.in}} -->
      <article class="contents">
        <div v-show="currentTab == 0">
          <div class="form">
            <div class="form-row">
              <div class="item-desc">
                <!-- 전화번호 저장 X [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
                <select-box
                  ref="smsCnpt"
                  :value.sync="$store.state.auth.commMotpCertn.sendCetrNo.in.cphnNo"
                  :option-list="getSMSCnptList"
                  label-i18n="MOTP-01-07-01-03"
                  @selected="selectedCpnt"
                  :required="_.isEmpty(getRBF0409E40.out.success.emad1)"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="item-tit">{{ /*이메일 주소*/ $t("MOTP-01-07-01-04") }}</div>
              <div class="item-desc">
                <div class="form-text-field email">
                  <div class="input-text-field">
                    <input
                      type="text"
                      id="name"
                      :value="getRBF0409E40.out.success.emad1"
                      class="form-control"
                      placeholder
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="info info-help" @click="actionSheet003 = true">
              <i class="icon icon-help" />
              {{ /*휴대폰 번호나 이메일 주소를 변경하셨나요?*/ $t("MOTP-01-07-01-05") }}
            </div>
            <!-- action sheet 들어 가는 곳 -->
            <!-- "MOTP-01-05-08-01": "휴대폰/이메일 변경 안내"-->
            <sms-email-info-pop :opened.sync="actionSheet003" />
            <!--// end -->
          </div>
        </div>
        <div v-show="currentTab == 1">
          <article
            v-if="getRBF0409E40.out.success.scurtyDeviVndrDstcd === '004' || getRBF0409E40.out.success.scurtyDeviVndrDstcd === '304'"
          >
            <div class="form">
              <div class="form-text-field">
                <label
                  for="name"
                  class="form-label"
                >{{ /*발급된 OTP 기기 일련번호*/ $t("MOTP-01-07-02-03") }}</label>
                <div class="input-text-field" @click="type3 = true">
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    placeholder
                    maxlength="15"
                    :value="getRBF0409E40.out.success.otpUniqIdnfiNo"
                    readonly
                  />
                </div>
              </div>
              <div class="info info-help" @click="actionSheet004 = true">
                <i class="icon icon-help" />
                {{ /*발급된 OTP 기기 일련번호*/ $t("MOTP-01-07-02-03") }}
              </div>
            </div>

            <!--"MOTP-01-07-04-01": "OTP 기기 일련번호 확인"-->
            <action-sheet
              class="action-sheet"
              :opened.sync="actionSheet004"
              :action-header="true"
              :action-footer="true"
              :use-top-border="true"
              title="MOTP-01-07-04-01"
            >
              <template #content>
                <ul class="ulist ulist-type--bullet">
                  <li>{{/* 지점에서 발급받은 TokenOTP 발생기 뒷면을 보시면 ①을 확인 하실 수 있습니다. */ $t("MOTP-01-07-04-02") }}</li>
                  <li>{{ /* TokenOTP를 분실한 경우, 영업점에서 재발급이 가능합니다. */ $t("MOTP-01-07-04-04") }}</li>
                </ul>
                <div class="cont-img">
                  <i class="icon icon-token-otp-sn"></i>
                </div>
              </template>
              <template #footer>
                <button
                  class="btn bottom positive"
                  @click="actionSheet004 = !actionSheet004"
                >{{ /*확인*/ $t("MOTP-01-07-03-05") }}</button>
              </template>
            </action-sheet>
          </article>
          <article v-else>
            <div class="cont-img">
              <i class="icon icon-token-otp op50" />
            </div>
            <!--고객님은 발급 받으신<br/>Token OTP가 없습니다.-->
            <strong class="info-question" v-html="$t('MOTP-08-01-02-02')"></strong>
          </article>
        </div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button
        :class="`btn md ${FN004() ? 'normal' : 'disabled'}`"
        v-on:click="FN002"
      >{{ /*다음*/ $t("MOTP-01-07-02-05") }}</button>
    </div>
  </article>
</template>
<style type="scss" scoped></style>
<script>
import { mapGetters, mapActions } from "vuex";
import Common from "@/components/basic/Common";
import SmsEmailInfoPop from "@/components/page/auth/SmsEmailInfoPop";

export default {
  name:"SelfCertnComm",
  extends: Common,
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
    beforeRouterName: {
      type: String,
      required: true,
    },
  },
  components: {
    SmsEmailInfoPop
  },
  async created() {
    this.$log.info("SelfCertnComm - SMS/EMAIL 인증 공통처리");
    this.act_sendCetrNo_init(); //인증코드 요청 초기화
    this.act_sendCetrNoConfirm_init();

    // 고객정보조회
    await this.FN001();
  },
  mounted() {},
  updated() {},
  data() {
    return {
      currentTab: 0,
      tabs: ["Mobile or E-Mail", "Token OTP"],
      // actionSheet001: false,
      // actionSheet002: false,
      actionSheet003: false,
      actionSheet004: false,
      token: true,
    };
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getRBF0409E40", "getSMSCnptList"]),
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act001_commMotpCertn", "act_setComponent", "act_sendCetrNo_init", "act_sendCetrNoConfirm_init"]),
    /**
     * 고객정보조회 + tokenOTP 번호 조회..
     */
    FN001: async function () {
      const result = await this.act001_commMotpCertn();
      this.$log.info("result(" + result + ") >>> " + JSON.stringify(this.getRBF0409E40));
    },
    /**
     * 다음버튼 클릭시..
     */
    FN002: function () {
      if (this.currentTab === 0) {
        // email, sms
        if (_.isEmpty(this.$store.state.auth.commMotpCertn.sendCetrNo.in.cphnNo) && _.isEmpty(this.getRBF0409E40.out.success.emad1)) {
          this.$refs.smsCnpt.$v.$touch();
          if (this.$refs.smsCnpt.$v.$invalid) {
            return;
          }
        } else if (
          _.isNil(this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd) ||
          _.isEmpty(this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd) ||
          this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn != "1"
        ) {
          this.act_setComponent("SmsFrstCertn");
        } else {
          this.act_setComponent("SmsEmailCertn");
        }
        //다음버튼 클릭 시 Email 주소 셋팅
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.emailAddr = this.getRBF0409E40.out.success.emad1;
      } else if (this.currentTab === 1) {
        // otp
        this.$router.push({ name: "createMotpStep5" });
      }
    },
    /**
     * 다음버튼 활성화 조건..
     */
    FN004: function () {
      let result = false;
      // sms/email
      if (this.currentTab === 0 && (this.getRBF0409E40.out.success.cphnNo !== "" || this.getRBF0409E40.out.success.emad1 !== "")) {
        result = true;
      }
      // otp
      if (this.currentTab === 1 && this.getRBF0409E40.out.success.otpUniqIdnfiNo !== "") {
        result = true;
      }
      return result;
    },

    selectedCpnt(text, data) {
      this.act_sendCetrNo_init();
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.ovsesSMSBzwkDstcd = data.ovsesSMSBzwkDstcd;
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.cphnNo = data.cntpCtnt;
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.cntpSerno = data.cntpSerno;
      this.$store.state.auth.commMotpCertn.sendCetrNo.in.msgSendPtrnCd = "1"; // "1":SMS, "2":Email, "3":PUSH

      this.$log.info("data >>> " + JSON.stringify(data));
      if (_.isNil(data.brncoIntnTelDstcd) || _.isEmpty(data.brncoIntnTelDstcd) || data.recvCnsntYn != "1") {
        //재인증이 필요한 경우
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.ovsesSMSBzwkDstcd = data.ovsesSMSBzwkDstcd;
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd = "";
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCphnNo = "";
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCnsntYn = "";
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn = "";
      } else {
        //재인증이 필요없는 경우
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.ovsesSMSBzwkDstcd = data.ovsesSMSBzwkDstcd;
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnNatnlCd = data.brncoIntnTelDstcd;
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCphnNo = data.cntpCtnt;
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.certnCnsntYn = "";
        this.$store.state.auth.commMotpCertn.sendCetrNo.in.recvCnsntYn = data.recvCnsntYn;
      }
      this.$log.info("sendCetrNo >>> " + JSON.stringify(this.$store.state.auth.commMotpCertn.sendCetrNo.in));
    },
  },
};
</script>